import axios, { AxiosError, CancelTokenSource } from "axios";

import { apiClient } from "./base-services.request";
import { getTokenUser } from "@/src-refactor/modules/shared/helpers/getUserInfo.helpers";

const pendingRequests: { [key: string]: CancelTokenSource } = {};

export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({
    url,
    method,
    data,
    params,
    body,
    content_type,
    Headers,
    responseType,
    timeOut
  }: any) => {
    const key = JSON.stringify({ url, method, data, params, body });
    if (pendingRequests[key]) {
      // si la solicitud ya existe, cancelarla
      pendingRequests[key].cancel(
        "La solicitud ha sido cancelada debido a una solicitud duplicada"
      );
      delete pendingRequests[key];
    }

    try {
      const source: CancelTokenSource = axios.CancelToken.source();
      pendingRequests[key] = source;
      const result = await apiClient({
        url: baseUrl + url,
        method,
        data: body,
        params,
        timeout: timeOut ?? 90000,
        responseType: responseType ?? undefined,
        headers: {
          Authorization: `Bearer ${getTokenUser()?.token}`,
          "X-AUTH-TOKEN": getTokenUser()?.maxCoreTokenV1,
          "Content-Type": content_type || "multipart/form-data",
          Accept: "*/*",
          ...Headers
        },
        cancelToken: source.token
      });
      // eliminar la solicitud pendiente
      delete pendingRequests[key];
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      if (err.code !== "ERR_CANCELED") {
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message
          }
        };
      } else {
        return {
          error: {
            code: "cancel"
          }
        };
      }
    }
  };
